<template>
  <div>
    <div class="tab">
      <div class="tab__header">
        <div class="tab__title h2">Экзамены</div>
      </div>

      <loader v-if="isLoading.collections"></loader>
      <div v-else class="tab__content">
        <router-link
          v-for="exam of exams"
          :to="{ path: `/pdd/exams/${exam.id}`, query: { exam: exam.exam } }"
          :key="exam.id + exam.name"
          :class="getExamClass(exam.id)"
          class="exam">
          <div class="exam__content">
            <div class="exam__title">{{ exam.name }}</div>

            <div v-if="getExamResult(exam.id) && !getExamResult(exam.id).passed" class="exam__status">
              <div class="correct">{{ getExamResult(exam.id).right }}</div>
              <div class="error">{{ getExamResult(exam.id).wrong }}</div>
            </div>

            <p v-if="!getExamResult(exam.id)" class="exam__status">Не выполнен</p>
            <p v-if="getExamResult(exam.id) && getExamResult(exam.id).passed" class="exam__status">Выполнен</p>
          </div>
        </router-link>
        <router-link
          v-for="constructor of constructors"
          :to="{ path: `/pdd/exams/constructors/${constructor.id}` }"
          :key="constructor.id  + constructor.name"
          :class="getConstructorClass(constructor.id)"
          class="exam">
          <div class="exam__content">
            <div class="exam__title">{{ constructor.name }}</div>

            <div v-if="getConstructorResult(constructor.id) && !getConstructorResult(constructor.id).passed" class="exam__status">
              <div class="correct">{{ getConstructorResult(constructor.id).right }}</div>
              <div class="error">{{ getConstructorResult(constructor.id).wrong }}</div>
            </div>

            <p v-if="!getConstructorResult(constructor.id)" class="exam__status">Не выполнен</p>
            <p v-if="getConstructorResult(constructor.id) && getConstructorResult(constructor.id).passed" class="exam__status">Выполнен</p>
          </div>
        </router-link>
      </div>
    </div>

    <div class="message">
      <div class="message__icon">
        <img src="../../../html/assets/img/icon-time.svg">
      </div>
      <div class="message__text">Время сдачи экзамена - 20 минут.</div>
    </div>
  </div>
</template>

<script>
  import mainMixin from '../../mixins/tests/main';

  export default {
    name: 'Exams',
    mixins: [mainMixin],
    computed: {
      exams() {
        return this.$store.getters.collectionsExams;
      },
      constructors() {
        return this.$store.getters.constructors;
      },
      isLoading() {
        return this.$store.getters.collectionsLoaders;
      },
    },
    methods: {
      getExams() {
        this.$store.dispatch('getCollections');
        this.$store.dispatch('getConstructors');
      },
      getExamResult(examId) {
        const examResults = (this.$appSettings && this.$appSettings.examResults) || [];
        let examInfo = null;

        for (const exam of examResults) {
          if (exam.examId === parseInt(examId, 10)) {
            examInfo = exam;
            break;
          }
        }

        return examInfo;
      },
      getConstructorResult(examId) {
        if (!this.$appSettings.constructorResults) {
          this.$appSettings.constructorResults = [];
          this.updateAppSettings();
        }

        const { constructorResults } = this.$appSettings;

        let examInfo = null;

        for (const exam of constructorResults) {
          if (exam.examId === parseInt(examId, 10)) {
            examInfo = exam;
            break;
          }
        }

        return examInfo;
      },
      getExamClass(exam) {
        const isTicketHasResult = this.getExamResult(exam);
        const className = {};

        if (isTicketHasResult && this.getExamResult(exam).passed) {
          className['exam-success'] = true;
        } else if (this.getExamResult(exam)) {
          className['exam-passed'] = true;
        }

        return className;
      },
      getConstructorClass(exam) {
        const isTicketHasResult = this.getConstructorResult(exam);
        const className = {};

        if (isTicketHasResult && this.getConstructorResult(exam).passed) {
          className['exam-success'] = true;
        } else if (this.getConstructorResult(exam)) {
          className['exam-passed'] = true;
        }

        return className;
      },
    },
    created() {
      this.getExams();
    },
  };
</script>
